var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{attrs:{"cols":"12"}},[_c('v-img',{staticClass:"mx-auto mt-1",staticStyle:{"width":"90vw","height":"90vw"},attrs:{"src":_vm.Articulo.Imagen}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }